import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { SpaLoadPeriodDTO } from '@api';

@Component({
  selector: 'spa-bar-chart-capacity',
  templateUrl: './bar-chart-capacity.component.html',
  styleUrls: ['./bar-chart-capacity.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarChartCapacityComponent {
  @Input() timeLoad: SpaLoadPeriodDTO | undefined;

  @HostBinding('class.show-counts')
  @Input()
  showCounts = false;

  get present() {
    return this.timeLoad?.load.present ?? 0;
  }

  get reserved() {
    return this.timeLoad?.load.reserved ?? 0;
  }

  get available() {
    return this.timeLoad?.load.available ?? 0;
  }

  get free() {
    return this.available - (this.reserved + this.present);
  }
}
